import { useCallback } from 'react';
import { useTrackEvent } from 'src/modules/analytics/useTrackAnalytics';
import {
  PlatformFeeEventLabels,
  PlatformFeeEventsMap,
  type TrackPlatformFeeEvent,
} from './events';

/**
 * Custom hook to handle LOM tracking events
 */
export function useTrackPlatformFeeAnalytics() {
  const trackEvent = useTrackEvent();

  return useCallback(
    (event: TrackPlatformFeeEvent, extra?: Record<string, unknown>) => {
      const eventLabel = PlatformFeeEventLabels[event];
      const eventInfo = PlatformFeeEventsMap[event];
      trackEvent(eventLabel, {
        ...eventInfo,
        ...extra,
      });
    },
    [trackEvent],
  );
}
